
export default [
	{
		title: 'Auto Campaign',
		subTitle: 'Select the Type',
		content: [
			'Birthday - Send customers a birthday offer',
      'Membership Anniversary - send customers an offer every year around the time they joined your program',
      'Lost Customer - select a period of time to send customer that haven\'t been in during that time period a message',
      'Anniversary - send an offer for 2 on their wedding anniversary'
		]
	},
	{
		title: 'What the Campaign is',
		subTitle: 'When to send what',
		content: [
			'Send to all your customers'
		]
	},
	{
		title: 'The Offer',
		subTitle: 'The Carrot',
		content: [
			'Name the offer for you and your team.',
			'Customer display is shown on the tablet and online when the customer views this offer.',
			`Cashier directions is shown on the tablet to the cashiers to direct them how to redeem this offer for the customer.`,
			'Promotion Method Auto Accept means no user action required.',
			'Promotion Method User Claim means the user will get a text with a link, they must click this link.',
			'What dates do you want this offer valid for?',
			'Don\'t worry you don\'t have to provide a carrot just check the box at the bottom.'
		]
	},
	{
		title: 'Confirmation Page',
		subTitle: 'Confirm the Campaign',
		content: [ 'Please confirm the details of the campaign and we\'ll get it ready to go out for you.' ]
	},
]



/** WEBPACK FOOTER **
 ** ./src/helpers/AutoCampaignInfo.js
 **/